import apiClient from '../api/client';

export const getApplicants = async (params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );
  const { data } = await apiClient.get('/admin/applicants', { params: cleanParams });
  return data;
};

export const getApplicant = async (id) => {
  const { data } = await apiClient.get(`/admin/applicants/${id}`);
  return data;
};

export const updateApplicantStatus = async (id, status, adminNotes) => {
  const { data } = await apiClient.patch(`/admin/applicants/${id}/status`, {
    status,
    admin_notes: adminNotes
  });
  return data;
};

export const getPaymentLogs = async (id) => {
  const { data } = await apiClient.get(`/admin/applicants/${id}/payment-logs`);
  return data;
};

export const initiateRefund = async (id, reason) => {
  const { data } = await apiClient.post(`/admin/applicants/${id}/refund`, { reason });
  return data;
};
